<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :back-title="'뒤로가기'" :title="'멤버십 안내'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll;">
            <div class="background_image">
                <div style="color: #fff; text-align: center;">
                    <div style="padding-top: 61px; font-size: 28px; line-height: 36px; font-weight: 700;">
                        새로운 <span style="color: var(--color-main);">유소년 선수 영입</span>이<br>
                        필요하신가요?
                    </div>
                    <div style="margin-top: 17px; font-weight: 500; font-size: 14px; line-height: 24px;">
                        그라운드에서 땀 흘리는 열정 가득 학생들부터,<br>
                        이적시장에 준비된 엘리트 선출들까지<br>
                        모두 만나볼 수 있어요!
                    </div>
                    <div style="margin-top: 10px; font-weight: 500; font-size: 14px; line-height: 24px; padding-bottom: 20px;">
                        제안은 부담 없이!<br>
                        선수가 수락할 때만 차감됩니다.
                    </div>
                </div>
            </div>
            <div style="margin-top: 26px;">
                <div class="explanation_container">
                    <div class="explanation_wrapper">
                        <div class="beige_circle">
                            <img style="width: 20px;" :src="require('@/assets/img/membership_icon1.png')" alt="">
                        </div>
                        <div class="explanation_title">자유롭게</div>
                        <div class="explanation_subtitle">선수 탐색</div>
                    </div>
                    <div class="explanation_divider"></div>
                    <div class="explanation_wrapper">
                        <div class="beige_circle">
                            <img style="width: 20px;" :src="require('@/assets/img/membership_icon2.png')" alt="">
                        </div>
                        <div class="explanation_title">부담없이</div>
                        <div class="explanation_subtitle">스카우트 제안</div>
                    </div>
                    <div class="explanation_divider"></div>
                    <div class="explanation_wrapper">
                        <div class="beige_circle">
                            <img style="width: 20px;" :src="require('@/assets/img/membership_icon3.png')" alt="">
                        </div>
                        <div class="explanation_title">선수가 수락시</div>
                        <div class="explanation_subtitle">스카우트권<br>1회 차감</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 45px; padding: 24px; background-color: #F2F2F2;">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="font-weight: 700; line-height: 24px;">이용권 선택</div>
                    <div @click="showScoutGuide" style="font-weight: 500; font-size: 12px; color: #808080; text-decoration: underline;">스카우트 사용 가이드</div>
                </div>
                <div style="margin-top: 20px;">
                    <div class="ticket_wrapper" :class="selectedTicket === TICKET_TYPE.PRO ? 'selected_pro' : ''" @click="selectTicket(TICKET_TYPE.PRO)">
                        <div class="ticket_title">
                            <div class="ticket_title_text">PRO 스카우트</div>
                            <div class="check_circle" :class="selectedTicket === TICKET_TYPE.PRO ? 'selected' : 'un_selected'">
                                <img style="width: 14px;" :src="require('@/assets/img/white_check_new.png')" alt="">
                            </div>
                        </div>
                        <div class="ticket_content_wrapper">
                            <ul style="padding: 0; padding-left: 20px; margin: 0; padding-bottom: 17px;">
                                <li>스카우트 제안 <span>자유롭게 발송</span></li>
                                <li style="margin-top: 5px;">이적시장 스카우트권 <span>월 15회</span>자동 충전</li>
                                <li style="margin-top: 5px;">그라운드 스카우트권 <span>월 30회</span>자동 충전</li>
                                <li style="margin-top: 5px;">시크릿 입단 요청서 열람권 할인 <span>[건당 3,000원]</span></li>
                            </ul>
                        </div>
                        <div class="ticket_price_wrapper" style="">
                            <div class="ticket_price_title">월 정기 구독</div>
                            <div class="ticket_price_value">
                                <div class="ticket_cost">54,000</div>
                                <div class="ticket_discount">29,000<span>원</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <div class="ticket_wrapper" :class="selectedTicket === TICKET_TYPE.LITE ? 'selected_lite' : ''" @click="selectTicket(TICKET_TYPE.LITE)">
                        <div class="ticket_title">
                            <div class="ticket_title_text">LITE 스카우트</div>
                            <div class="check_circle" :class="selectedTicket === TICKET_TYPE.LITE ? 'selected_lite' : 'un_selected'">
                                <img style="width: 14px;" :src="require('@/assets/img/white_check_new.png')" alt="">
                            </div>
                        </div>
                        <div class="ticket_content_wrapper">
                            <ul style="padding: 0; padding-left: 20px; margin: 0; padding-bottom: 17px;">
                                <li>스카우트 제안 <span class="lite_text">자유롭게 발송</span></li>
                                <li style="margin-top: 5px;">이적시장 스카우트권 <span class="lite_text">월 7회</span>자동 충전</li>
                                <li style="margin-top: 5px;">그라운드 스카우트권 <span class="lite_text">월 10회</span>자동 충전</li>
                                <li style="margin-top: 5px;">시크릿 입단 요청서 열람권 할인 <span class="lite_text">[건당 5,000원]</span></li>
                            </ul>
                        </div>
                        <div class="ticket_price_wrapper" style="">
                            <div class="ticket_price_title">월 정기 구독</div>
                            <div class="ticket_price_value">
                                <div class="ticket_cost">54,000</div>
                                <div class="ticket_discount">29,000<span>원</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 24px; padding: 0 24px; margin-bottom: 23px;">
                <div style="font-weight: 700; line-height: 24px;">구독 및 결제 유의사항</div>
                <ul style="padding: 0; margin: 0; margin-top: 13px; padding-left: 24px; color: #000;">
                    <li style="font-size: 12px; line-height: 20px;">본 멤버십은 매월 지정된 결제일에 자동 결제되는 <span style="font-weight: 700;">월 정기 구독 상품</span>입니다.</li>
                    <li style="margin-top: 4px;font-size: 12px; line-height: 20px;">매월 충전되는 스카우트권은 다음 결제일 전까지 사용 가능하며, 
                        <span style="font-weight: 700; color: var(--color-main);">미사용 잔여분은 이월되지 않고 자동 소멸</span>됩니다.
                    </li>
                    <li style="margin-top: 4px;font-size: 12px; line-height: 20px;">결제가 완료된 이후에는
                        <span style="font-weight: 700; color: var(--color-main);">사용 이력과 무관하게 환불이 불가</span>합니다.<br>
                        다음 결제를 원치 않으실 경우 마이페이지에서 언제든지 구독을 해지하실 수 있습니다.
                    </li>
                </ul>
            </div>
        </div>
        <div style="margin-top: 12px; padding: 0 24px; margin-bottom: 20px;">
            <div :class="setActiveClass()" class="common_btn">결제하기</div>
        </div>
        <CommonPopupFrame :isOpen="isShowScoutGuide" :closeCompleteAction="closeScoutGuide" :maxHeight="maxHeight" :changeHeight="'auto'" :changeBottom="0">
            <div style="display: flex; flex-direction: column; flex: 1; overflow: hidden;">
                <div style="margin-bottom: 30px;" class="common_popup_header"></div>
                <div @touchmove.stop="() => { }" style="padding: 0 24px; font-weight: 700; flex: 1; overflow-y: scroll;">
                    <div style="font-size: 24px; font-weight: 900; line-height: 32px;">스카우트 사용 가이드</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #797979;">더 많은 선수들에게 스카우트 요청을 해보세요.</div>
                    <div style="margin: 30px 0;">
                        <div v-for="each, i in scoutGuideList" :key="i" :style="{ paddingTop: i === 0 ? '0' : '18px' }" style="padding-bottom: 18px; border-bottom: 1px solid #eee;">
                            <div @click="toggleScoutFaq(i)" style="display: flex; justify-content: space-between; align-items: center;">
                                <div :style="{ color: isScoutGuideOpen(i) ? 'var(--color-main)' : '' }" style="font-weight: 700; line-height: 24px;">{{ each.title }}</div>
                                <div style="margin-bottom: 4px;">
                                    <img v-if="!isScoutGuideOpen(i)" style="width: 8px;" :src="require('@/assets/img/arrow_small.png')" alt="">
                                    <img v-else style="width: 8px;" :src="require('@/assets/img/arrow_small_up.png')" alt="">
                                </div>
                            </div>
                            <template v-if="isShowAnswer(0, i)">
                                <div style="margin-top: 15px;">
                                    <div class="answer_title">이적시장 스카우트</div>
                                    <div class="answer_desc">이적시장에 입단 요청서를 등록한 엘리트 선수와, 축구선수를 목표로 진지하게 준비 중인 비선출 선수를 스카우트할 때 사용해요.</div>
                                </div>
                                <div style="margin-top: 15px;">
                                    <div class="answer_title">그라운드 스카우트</div>
                                    <div class="answer_desc">그라운드에 훈련 영상을 올린 비선출 선수가 마음에 들 때, 입단 테스트를 제안할 때 사용해요.</div>
                                </div>
                                <div style="margin-top: 15px;">
                                    <div class="answer_title">시크릿 입단 요청서 열람</div>
                                    <div class="answer_desc">신분을 비공개로 유지한 채 이적을 준비 중인 선수의 입단 요청서를 열람할 때 사용됩니다. 조용한 이적을 원하는 선수이므로, 연락 시에도 배려 있게 진행해 주세요.<br>
                                        해당 기능은 요금제와 별도로 이용 요금이 발생하며, 요금제 등급에 따라 열람 비용이 다르게 적용됩니다.</div>
                                </div>
                            </template>
                            <template v-else-if="isShowAnswer(1, i)">
                                <div style="margin-top: 15px;">
                                    <div style="border: 1px solid #ffedd5; background-color: #fff8f1;" class="answer_box">
                                        <div style="color: #b36300;" class="answer_box_title">이적시장</div>
                                        <div class="answer_box_market_desc">
                                            <span>엘리트 선수,</span> 또는 <span>비용을 지불하고서라도 진지하게 축구선수가 되고 싶은 열정 넘치는 학생들</span>이
                                            입단 요청서를 올리는 <span>공식적인 스카우트 영입 공간</span>이에요.<br>
                                            즉시 팀의 전력이 될 선수를 찾을 때 활용하세요.
                                        </div>
                                    </div>
                                    <div style="margin-top: 20px; border: 1px solid #dbf0ff; background-color: #e8f3ff;" class="answer_box">
                                        <div style="color: #1B64DA;" class="answer_box_title">그라운드</div>
                                        <div class="answer_box_ground_desc">
                                            일반 학생들이 <span>훈련 영상을 올리는 커뮤니티</span>예요.<br>
                                            영상을 보고 "오, 잘하네? 테스트 한 번 받아볼래?"하고 가볍게 다가가며 
                                            <span>숨은 원석을 발굴하는 공간</span>이에요.
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="isShowAnswer(2, i)">
                                <div style="margin-top: 15px;">
                                    <div class="answer_title">✅ 스카우트 제안 발송은 무료!</div>
                                    <div class="answer_desc">부담 없이 선수들에게 마음껏 찔러보세요.<br>
                                        선수들에게 제안을 보내는 단계에서는 스카우트 횟수가 깍이지 않아요.
                                    </div>
                                </div>
                                <div style="margin-top: 15px;">
                                    <div class="answer_title">✅ 선수가 스카우트 제안 수락시 1회 차감!</div>
                                    <div class="answer_desc">선수가 스카우트 제안을 수락하면<br>
                                        스카우트 1회가 차감되고, 메시지로 대화를 시작할 수 있어요.
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="isShowAnswer(3, i)">
                                <div style="margin-top: 15px;">
                                    <div class="answer_desc">그라운드에 올라온 훈련 영상에 진심 어린 피드백을 남겨주시면 스카우트 이용권을 드려요.</div>
                                </div>
                                <div style="margin-top: 15px;">
                                    <div style="padding: 20px; border-radius: 24px; background: #210F030D;">
                                        <div style="display: flex; align-items: center; justify-content: space-between; padding-bottom: 11px; border-bottom: 1px solid #fff;">
                                            <div style="font-weight: 900; font-size: 14px; line-height: 24px;">피드백 1개 작성 시</div>
                                            <div style="font-weight: 900; font-size: 14px; line-height: 24px; color: #2977F5;">그라운드 스카우트 1회 지급</div>
                                        </div>
                                        <div style="display: flex; align-items: center; justify-content: space-between; padding-top: 11px;">
                                            <div style="font-weight: 900; font-size: 14px; line-height: 24px;">피드백 5개 작성 시</div>
                                            <div style="font-weight: 900; font-size: 14px; line-height: 24px; color: var(--color-main);">이적시장 스카우트 1회 지급</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div style="padding: 0 24px;">
                    <div @click="closeScoutGuide" style="height: 52px; border-radius: 12px; background-color: #000; color: #fff; font-weight: 500; font-size: 14px; line-height: 52px; text-align: center; margin-bottom: 30px;">확인했어요</div>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader";
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame";

const TICKET_TYPE = {
    PRO: 'PRO',
    LITE: 'LITE',
}

export default {
    name: "MembershipGuide",
    components: {
        MercenaryHeader,
        CommonPopupFrame
    },
    created() {
        this.maxHeight = window.innerHeight
    },
    data() {
        return {
            selectedTicket: null,
            TICKET_TYPE: TICKET_TYPE,
            maxHeight: 0,
            isShowScoutGuide: false,
            scoutGuideList: [
                {
                    title: '각 스카우트권은 어디에 쓰나요?',
                },
                {
                    title: '이적시장이랑 그라운드, 무슨차이인가요?',
                },
                {
                    title: '횟수는 언제 차감되나요?',
                },
                {
                    title: '스카우트 무료획득 꿀팁',
                },

            ],
            openFaqIndex: null,
        }
    },
    methods: {
        showScoutGuide() {
            this.isShowScoutGuide = true
        },
        closeScoutGuide() {
            this.openFaqIndex = null
            this.isShowScoutGuide = false
        },
        selectTicket(ticketType) {
            this.selectedTicket = ticketType;
        },
        setActiveClass() {
            if (this.selectedTicket === TICKET_TYPE.PRO) {
                return 'active_pro';
            } else if (this.selectedTicket === TICKET_TYPE.LITE) {
                return 'active_lite';
            }
            return 'un_active';
        },
        toggleScoutFaq(index) {
            this.openFaqIndex = this.openFaqIndex === index ? null : index
        },
        isScoutGuideOpen(index) {
            return this.openFaqIndex === index
        },
        isShowAnswer(activeIndex, index) {
            return this.openFaqIndex === index && index === activeIndex
        }
    }
}
</script>

<style scoped>
.background_image {
    background-image: url('~@/assets/img/membership_back.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    /* min-height: 300px; */
}

.beige_circle {
    width: 40px;
    height: 40px;
    background: #FF71111A;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.explanation_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.explanation_container {
    display: flex;
    /* justify-content: space-around; */
    padding: 0 35px;
}

.explanation_title {
    margin-top: 5px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
}

.explanation_subtitle {
    line-height: 24px;
    text-align: center;
    font-weight: 700;
}

.explanation_divider {
    flex: 1;
    height: 2px;
    background-color: #FF711133;
    margin-top: 18px;
    /* background: #FF71111A; */
}

.ticket_wrapper {
    padding: 20px;
    border: 2px solid #BBBBBB;
    border-radius: 24px;
    background-color: #fff;
}

.ticket_content_wrapper {
    margin-top: 15px;
    border-bottom: 1px solid #eee;
}

.check_circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ticket_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ticket_title_text {
    font-weight: 900;
    font-size: 24px;
    line-height: 32px;
}

.un_selected {
    border: 1px solid #bbb;
}

.selected {
    background-color: var(--color-main);
}

.ticket_content_wrapper li {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
}

.ticket_content_wrapper li span {
    font-weight: 700;
    color: var(--color-main);
}

.ticket_price_wrapper {
    margin-top: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ticket_price_title {
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: #808080;
}

.ticket_price_value {
    display: flex;
    align-items: flex-start;
    gap: 4px;
}

.ticket_cost {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: #808080;
    text-decoration: line-through;
}

.ticket_discount {
    font-weight: 700;
    font-size: 24px;   
    line-height: 24px;
}

.ticket_discount span {
    font-size: 14px;
}

.lite_text {
    color: #2977F5;
}

.selected_lite {
    border-color: #2977F5;
    border-width: 2px;
}

.selected_pro {
    border-color: var(--color-main);
    border-width: 2px;
}

.common_btn {
    border-radius: 12px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    /* background-color: var(--color-main); */
    color: #fff;
    font-weight: 700;
    font-size: 14px;
}

.un_active {
    background-color: #d9d9d9;
}

.active_pro {
    background-color: var(--color-main);
}

.active_lite {
    background-color: #2977F5;
}

.common_popup_header {
    width: 36px;
    height: 5px;
    background-color: #d9d9d9;
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 5px;
}

.scout_guide_desc {
    line-height: 20px;
    font-size: 12px;
    font-weight: 500;
}

.answer_title {
    font-weight: 900;
    font-size: 14px;
    line-height: 24px;
}

.answer_desc {
    margin-top: 5px;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
}

.answer_box {
    padding: 20px;
    border-radius: 24px;
}

.answer_box_title {
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 10px;
}

.answer_box_market_desc {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #B36300E5;
}

.answer_box_market_desc span {
    font-weight: 700;
    color: #EA580C;
}

.answer_box_ground_desc {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #1B64DAE5;
}

.answer_box_ground_desc span {
    font-weight: 700;
    color: #3182F6;
}
</style>